/*@ngInject*/
const ReportRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getReportList = function (submissionId) {
        var url = '/rest/ExternalReport/List?submissionId=' + submissionId;

        return this.get(url);
    };
};

angular.module('gw-um-submission')
    .service('reportRepository', ReportRepository);
